import React from "react"
import { Layer, Source } from "react-map-gl/mapbox"

interface CadastreGouvLayerProps {
  opacity?: number
  cityCode: string
}

export const CadastreGouvLayer = ({ opacity = 0.5, cityCode }: CadastreGouvLayerProps) => {
  if (!cityCode) return null

  return (
    <React.Fragment key={cityCode}>
      <Source
        id="raster-cadastre-gouv"
        type="raster"
        tiles={[
          `https://inspire.cadastre.gouv.fr/scpc/${cityCode}.wms?service=WMS&VERSION=1.3&BBOX={bbox-epsg-3857}&FORMAT=image/png&service=WMS&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&LAYERS=AMORCES_CAD,LIEUDIT,CP.CadastralParcel,SUBFISCAL,CLOTURE,DETAIL_TOPO,HYDRO,VOIE_COMMUNICATION,BU.Building,BORNE_REPERE&STYLES=DEFAULT`,
        ]}
        tileSize={256}
      >
        <Layer
          id="raster-cadastre-gouv"
          type="raster"
          source="raster-cadastre-gouv"
          paint={{ "raster-opacity": opacity }}
        />
      </Source>
      <Source
        id="cadastre-gouv-vector"
        minzoom={11}
        maxzoom={16}
        type="vector"
        tiles={["https://openmaptiles.geo.data.gouv.fr/data/cadastre/{z}/{x}/{y}.pbf"]}
      >
        <Layer
          id="cadastre-gouv-parcels-line"
          source="cadastre-gouv-vector"
          source-layer="parcelles"
          type="line"
          paint={{
            "line-color": "#000000",
            "line-width": 1,
            "line-opacity": opacity,
          }}
        />
        <Layer
          id="cadastre-gouv-parcels-label"
          source="cadastre-gouv-vector"
          source-layer="parcelles"
          type="symbol"
          minzoom={16}
          filter={["!=", ["get", "section"], ""]}
          layout={{
            "text-field": ["concat", ["get", "section"], " ", ["get", "numero"]],
            "text-size": 14,
            "text-allow-overlap": false,
          }}
          paint={{
            "text-color": "#000000",
            "text-halo-color": "#ffffff",
            "text-halo-width": 1.5,
          }}
        />
      </Source>
    </React.Fragment>
  )
}
